import { createProxyApiUrl, getApiUrl } from '@moonpig/web-core-utils'

export const getDataInferenceUrl = (): string => {
  const apiUrl = getApiUrl()
  const url = createProxyApiUrl(`${apiUrl}/data-inference`, {})
  return url
}
